import { create } from 'zustand'

interface OperatorWebPaletteUiState {
  visible: boolean
  open: () => void
  close: () => void
  toggle: () => void
}

/**
 * Web marketing: operator impersonation launcher overlay (Cmd/Ctrl+K).
 * Keeps the current URL (`/`, `/privacy`, …); does not navigate to a dedicated route.
 */
export const useOperatorWebPaletteUiStore = create<OperatorWebPaletteUiState>((set, get) => ({
  visible: false,
  open: () => set({ visible: true }),
  close: () => set({ visible: false }),
  toggle: () => set({ visible: !get().visible }),
}))
